// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__OIEZi","wrapper":"Header_wrapper__2ESGX","wrapperLogo":"Header_wrapperLogo__3nA4X","profileSection":"Header_profileSection__3mZvR"};